import { Heading } from "@chakra-ui/react";
import SSOSettings from "features/Settings/SSO";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import { useEffect } from "react";

export default function SSOSettingsPage() {
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("SSO Settings");
    return () => {
      setBackLocationPath(null);
      setBackLocationName(null);
      setPageTitle(null);
    };
  }, [setBackLocationPath, setBackLocationName, setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <Heading mb="8" size="sm" color="fg.subtle">
          SSO Settings
        </Heading>
        <SSOSettings />
      </InnerSidebar>
    </AppPage>
  );
}
